import { AnyAction } from 'redux';
import { SET_SELECTED_DOCUMENT_TABLE } from '../types/types';

const initialState = {
	selectedDocumentTable: 'Users'
};

export default function tablesQuickAccessReducer(
	state = initialState,
	action: AnyAction
) {
	switch (action.type) {
		case SET_SELECTED_DOCUMENT_TABLE:
			return {
				selectedDocumentTable: action.selectedDocumentTable
			};
		default:
			return state;
	}
}
